/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-console */
import ggDASHConfig from './ggDASHConfig';

const env = ggDASHConfig.get('deployedEnv');

//  Outer object we attach custom handlers to below.
const logger = {
  error: str => {},
  warn: str => {},
  log: str => {},
};

if (env === 'production') {
  //  In production we want the majority of console calls to be
  //  silenced (console.log/info/debug/trace/group/etc.).
  Object.keys(console).forEach(key => {
    const slot = console[key];
    if (typeof slot === 'function') {
      //  NOTE these are essentially no-op functions to silence
      //  normal development log messages etc.
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      logger[key] = () => {};
    }
  });

  logger.error = (...args) => {
    console.error(...args);
  };
} else {
  //  In non-production environments we want logger.* to map to
  //  console.* without any extra overhead or filtering.
  Object.keys(console).forEach(key => {
    const slot = console[key];
    if (typeof slot === 'function') {
      //  NOTE these are effectively simple forwarding wrappers
      //  so invoking logger.* just calls console.*.
      logger[key] = (...args) => {
        console[key](...args);
      };
    }
  });
}

export default logger;
